import { render, staticRenderFns } from "./SickLeaveAttachModal.vue?vue&type=template&id=24489fca&scoped=true&"
import script from "./SickLeaveAttachModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveAttachModal.vue?vue&type=script&lang=ts&"
import style0 from "./SickLeaveAttachModal.vue?vue&type=style&index=0&id=24489fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24489fca",
  null
  
)

export default component.exports